const manageOrder = () => import("@/views/orders/manageOrder.vue");
const orderDetails = () => import("@/views/orders/orderDetails.vue");
const orderInvoice = () => import("@/views/orders/orderInvoice.vue");
const orderPreference = () => import("@/views/orders/orderPreference.vue");

export default {
  path: "manage-order",
  meta: {
    label: "Manage Order",
  },
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      meta: {
        requiresAuth: true,
      },
      component: manageOrder,
    },
    {
      path: ":orderId",
      name: "manage-order-details",
      meta: {
        label: "Order Details",
        requiresAuth: true,
      },
      component: orderDetails,
    },
    {
      path: "order-invoice/:id",
      name: "order-invoice",
      meta: {
        label: "Order Invoice",
        requiresAuth: true,
      },
      component: orderInvoice,
    },
    {
      path: "order-preference",
      name: "order-preference",
      meta: {
        label: "Order Preference",
        requiresAuth: true,
      },
      component: orderPreference,
    },
  ],
};
